import type { PriceAssessment, PriceAssessmentResult } from "@/lib/catalog-faq";
import type { DealPriceIndicator } from "@garimpa/lib/notificationEmails";

function assessmentWithDrop(
  base: PriceAssessment,
  withDrop: PriceAssessment,
  hasTrustedDrop: boolean,
): PriceAssessment {
  return hasTrustedDrop ? withDrop : base;
}

export function offerPriceAssessment(
  comparableHistory: boolean,
  comparisonIndicator: DealPriceIndicator | null,
  hasTrustedDrop: boolean,
): PriceAssessmentResult {
  if (!comparableHistory) {
    return { assessment: "insufficient_history", comparisonIndicator, hasTrustedDrop };
  }

  switch (comparisonIndicator) {
    case "all_time_high":
    case "above_typical":
    case "above_average":
      return {
        assessment: assessmentWithDrop("expensive", "expensive_with_drop", hasTrustedDrop),
        comparisonIndicator,
        hasTrustedDrop,
      };
    case "all_time_low":
      return {
        assessment: assessmentWithDrop("all_time_low", "all_time_low_with_drop", hasTrustedDrop),
        comparisonIndicator,
        hasTrustedDrop,
      };
    case "below_typical":
    case "below_average":
      return {
        assessment: assessmentWithDrop("below_typical", "below_typical_with_drop", hasTrustedDrop),
        comparisonIndicator,
        hasTrustedDrop,
      };
    default:
      return { assessment: "fair_price", comparisonIndicator, hasTrustedDrop };
  }
}
